const props = props => ({
  submit: () => {
    if (!props.email) {
      props.setStatus('noEmail')
    } else {
      props.setStatus('attempt')
      props.forgotPasswordAttempt(props.email)
    }
  }
})

export default props
